// extracted by mini-css-extract-plugin
export default {"block":"lq","active":"mq","label":"nq","disabled":"oq"};